import { createRouter, createWebHistory } from "vue-router";
import routerRoutes from '@/router/router'
import store from '@/store'
import api from '@/api/api'

// 관리자 전용 페이지 경로 목록
const ADMIN_ONLY_PATHS = [
    '/annualApl',
    '/annualAdminAll',
    '/annualAdminDetail',
]

const routes = [
    {
        path: "/",
        component: () => import("@/pages/DefaultLayout.vue"),
        children: [
            ...routerRoutes,
        ]
    },
    {
        path: "/error",
        name: 'error',
        meta: {
            title: '오류',
        },
        component: () => import("@/pages/common/Error.vue"),
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/schedInfo"
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

// Navigation Guard
router.beforeEach(async (to, from, next) => {
    const isAuthenticated = !!(store.state.userStore && store.state.userStore.accToken);
    const publicPaths = ['/', '/rePwd', '/error'];

    if (!isAuthenticated && !publicPaths.includes(to.path)) {
        // 미로그인 상태에서 보호 경로 접근 -> 로그인 페이지로
        next('/');
        return;
    }

    if (isAuthenticated && to.path === '/') {
        // 로그인 상태에서 로그인 페이지 접근 -> 스케줄 페이지로
        next('/schedInfo');
        return;
    }

    // 관리자 전용 페이지 접근 시 서버에서 권한 재확인
    const isAdminRoute = ADMIN_ONLY_PATHS.some(p => to.path === p || to.path.startsWith(p + '/'))
    if (isAuthenticated && isAdminRoute) {
        try {
            const res = await api.postUserInfo()
            const userData = res?.data?.data?.usrInf

            if (res?.data?.result && userData) {
                // 최신 유저 정보를 스토어에 갱신
                store.commit('userStore/saveUsrInfo', userData)

                if (userData.usrLvl !== '2') {
                    // 권한 없음 -> 토스트 띄우고 스케줄 페이지로 이동
                    store.dispatch('showToast', { msg: '접근 권한이 없습니다.', type: 'error' })
                    next('/schedInfo')
                    return
                }
            } else {
                // 유저 정보 조회 실패 -> 스케줄 페이지로
                store.dispatch('showToast', { msg: '사용자 정보를 확인할 수 없습니다.', type: 'error' })
                next('/schedInfo')
                return
            }
        } catch (e) {
            // 네트워크 오류 등 -> 인터셉터에서 처리하므로 여기선 차단만
            next('/schedInfo')
            return
        }
    }

    next();
});

export default router